// extracted by mini-css-extract-plugin
export var container = "_vk-0";
export var table = "_vk-2";
export var tableWrapper = "_vk-1";